import tinymce from './components/TinymceVue'

export default tinymce
export { tinymce }


//////////////////
// WEBPACK FOOTER
// ./~/vue-tinymce-editor/src/index.js
// module id = 7SKw
// module chunks = 1